import { VFC } from 'react';
import classNames from 'classnames';
import qrcodelogo from '../../../imgs/logo.svg';
import QRCode from 'qrcode.react';
import { usePx2RemRate } from '@hooks/usePx2RemRate';
import './index.scss';
const imageSettings = {
  src: qrcodelogo,
  width: 16,
  height: 16,
  excavate: false,
};

const PosterQrcode: VFC<{
  type: number;
  activityLink: string;
  color?: string;
  logo?: string;
  className?: string;
}> = ({ type, activityLink, logo, className }) => {
  const rate = usePx2RemRate();
  return (
    <div className={classNames('poster-qrcode', `type${type}`, className)}>
      <QRCode
        value={activityLink}
        size={68 * rate}
        level={'M'}
        imageSettings={{ ...imageSettings, width: 16 * rate, height: 16 * rate }}
        className="poster-qrcode-container"
      />
      <div className="poster-qrcode-info">
        {logo && (
          <img className="activity-logo" src={logo} draggable={false} crossOrigin="anonymous" />
        )}
        <div className="poster-qrcode-text">扫描二维码 报名活动</div>
        <div className="poster-qrcode-tip">SCAN CODE TO REGISTER</div>
      </div>
    </div>
  );
};

export default PosterQrcode;
